import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutateProjectsUsefulLinks = () => {
  const searchedKey = getCacheKey('/useful_links');
  if (searchedKey) {
    mutate(searchedKey);
  }
};
